const sharedDisabledTokens = {
  backgroundColor: 'fill-primary-disabled',
  borderColor: 'temp-future-border-primary-disabled',
  color: 'text-primary-disabled',
  cursor: 'auto'
};
export const setAsActive = useTokens => {
  useTokens.idle = useTokens.active;
  return useTokens;
};
export const getUseTokens = use => {
  const tokens = {
    primary: {
      idle: {
        backgroundColor: 'fill-primary-default',
        borderColor: 'fill-primary-default',
        color: 'text-core-on-fill-default'
      },
      hover: {
        backgroundColor: 'fill-primary-hover',
        borderColor: 'fill-primary-hover',
        color: 'text-core-on-fill-default',
        textDecoration: 'none'
      },
      active: {
        backgroundColor: 'fill-primary-pressed',
        borderColor: 'fill-primary-pressed',
        color: 'text-core-on-fill-default'
      },
      disabled: Object.assign({}, sharedDisabledTokens)
    },
    'primary-white': {
      idle: {
        backgroundColor: 'fill-inverse-default-alt',
        borderColor: 'border-inverse-default',
        color: 'text-inverse-default-alt'
      },
      hover: {
        backgroundColor: 'fill-inverse-hover-alt',
        borderColor: 'border-inverse-default',
        color: 'text-inverse-default-alt'
      },
      active: {
        backgroundColor: 'fill-inverse-pressed-alt',
        borderColor: 'border-inverse-default',
        color: 'text-inverse-default-alt'
      },
      disabled: Object.assign({}, sharedDisabledTokens)
    },
    secondary: {
      idle: {
        backgroundColor: 'temp-future-fill-secondary-default',
        borderColor: 'border-secondary-default',
        color: 'text-secondary-default'
      },
      hover: {
        backgroundColor: 'temp-future-fill-secondary-hover',
        borderColor: 'border-secondary-default',
        color: 'text-secondary-default',
        textDecoration: 'none'
      },
      active: {
        backgroundColor: 'temp-future-fill-secondary-pressed',
        borderColor: 'border-secondary-default',
        color: 'text-secondary-default'
      },
      disabled: Object.assign({}, sharedDisabledTokens)
    },
    'secondary-ghost': {
      idle: {
        backgroundColor: 'fill-inverse-default',
        borderColor: 'border-inverse-default',
        color: 'text-inverse-default'
      },
      hover: {
        backgroundColor: 'fill-inverse-hover',
        borderColor: 'border-inverse-default',
        color: 'text-inverse-default'
      },
      active: {
        backgroundColor: 'fill-inverse-pressed',
        borderColor: 'border-inverse-default',
        color: 'text-inverse-default'
      },
      disabled: Object.assign({}, sharedDisabledTokens)
    },
    tertiary: {
      idle: {
        backgroundColor: 'fill-transitional-tertiary-default',
        borderColor: 'border-transitional-tertiary-default',
        color: 'text-inverse-default'
      },
      hover: {
        backgroundColor: 'fill-transitional-tertiary-hover',
        borderColor: 'border-transitional-tertiary-default',
        color: 'text-inverse-default',
        textDecoration: 'none'
      },
      active: {
        backgroundColor: 'fill-transitional-tertiary-pressed',
        borderColor: 'border-transitional-tertiary-default',
        color: 'text-inverse-default'
      },
      disabled: Object.assign({}, sharedDisabledTokens)
    },
    'tertiary-light': {
      idle: {
        backgroundColor: 'fill-tertiary-default',
        borderColor: 'border-tertiary-default',
        color: 'text-tertiary-default'
      },
      hover: {
        backgroundColor: 'fill-tertiary-hover',
        borderColor: 'border-tertiary-default',
        color: 'text-tertiary-default',
        textDecoration: 'none'
      },
      active: {
        backgroundColor: 'fill-tertiary-pressed',
        borderColor: 'border-tertiary-default',
        color: 'text-tertiary-default'
      },
      disabled: Object.assign({}, sharedDisabledTokens)
    },
    'tertiary-extra-light': {
      idle: {
        backgroundColor: 'fill-secondary-default',
        borderColor: 'border-tertiary-default',
        color: 'text-tertiary-default'
      },
      hover: {
        backgroundColor: 'fill-tertiary-hover',
        borderColor: 'border-tertiary-default',
        color: 'text-tertiary-default',
        textDecoration: 'none'
      },
      active: {
        backgroundColor: 'fill-tertiary-pressed',
        borderColor: 'border-tertiary-default',
        color: 'text-tertiary-default'
      },
      disabled: Object.assign({}, sharedDisabledTokens)
    },
    danger: {
      idle: {
        backgroundColor: 'fill-alert-default',
        borderColor: 'fill-alert-default',
        color: 'text-alert-on-fill-default'
      },
      hover: {
        backgroundColor: 'fill-alert-hover',
        borderColor: 'fill-alert-hover',
        color: 'text-alert-on-fill-default',
        textDecoration: 'none'
      },
      active: {
        backgroundColor: 'fill-alert-pressed',
        borderColor: 'fill-alert-pressed',
        color: 'text-alert-on-fill-default'
      },
      disabled: Object.assign({}, sharedDisabledTokens)
    },
    transparent: {
      idle: {
        backgroundColor: 'fill-transparent-default',
        borderColor: 'fill-transparent-default',
        color: 'text-interactive-default'
      },
      hover: {
        backgroundColor: 'fill-transparent-default',
        borderColor: 'fill-transparent-default',
        color: 'text-interactive-default-hover'
      },
      active: {
        backgroundColor: 'fill-transparent-default',
        borderColor: 'fill-transparent-default',
        color: 'text-interactive-default-pressed'
      },
      disabled: Object.assign({}, sharedDisabledTokens, {
        backgroundColor: 'fill-transparent-default',
        borderColor: 'fill-transparent-default',
        color: 'text-interactive-default-disabled'
      })
    },
    unstyled: {
      idle: {
        backgroundColor: 'fill-surface-default',
        borderColor: 'border-core-on-fill-default',
        color: 'text-core-default'
      },
      hover: {
        backgroundColor: 'fill-surface-default',
        borderColor: 'border-core-on-fill-default',
        color: 'text-core-default',
        textDecoration: 'none'
      },
      active: {
        backgroundColor: 'fill-surface-default',
        borderColor: 'border-core-on-fill-default',
        color: 'text-core-default'
      },
      disabled: Object.assign({}, sharedDisabledTokens)
    },
    form: {
      idle: {
        backgroundColor: 'fill-surface-raised',
        borderColor: 'border-core-default',
        color: 'text-core-default'
      },
      hover: {
        backgroundColor: 'fill-surface-raised',
        borderColor: 'border-core-default',
        color: 'text-core-default',
        textDecoration: 'none'
      },
      active: {
        backgroundColor: 'fill-surface-raised',
        borderColor: 'border-core-default',
        color: 'text-core-default'
      },
      disabled: Object.assign({}, sharedDisabledTokens)
    },
    'form-on-dark': {
      idle: {
        backgroundColor: 'fill-surface-default',
        borderColor: 'border-core-default',
        color: 'text-core-default'
      },
      hover: {
        backgroundColor: 'fill-surface-default',
        borderColor: 'border-core-default',
        color: 'text-core-default',
        textDecoration: 'none'
      },
      active: {
        backgroundColor: 'fill-surface-default',
        borderColor: 'border-core-default',
        color: 'text-core-default'
      },
      disabled: Object.assign({}, sharedDisabledTokens)
    },
    link: {
      idle: {
        backgroundColor: 'fill-transparent-default',
        borderColor: 'fill-transparent-default',
        color: 'text-interactive-default'
      },
      hover: {
        backgroundColor: 'fill-transparent-default',
        borderColor: 'fill-transparent-default',
        color: 'text-interactive-default-hover'
      },
      active: {
        backgroundColor: 'fill-transparent-default',
        borderColor: 'fill-transparent-default',
        color: 'text-interactive-default-pressed'
      },
      disabled: Object.assign({}, sharedDisabledTokens, {
        backgroundColor: 'fill-transparent-default',
        borderColor: 'fill-transparent-default'
      })
    },
    'link-danger': {
      idle: {
        backgroundColor: 'fill-transparent-default',
        borderColor: 'fill-transparent-default',
        color: 'text-alert-default'
      },
      hover: {
        backgroundColor: 'fill-transparent-default',
        borderColor: 'fill-transparent-default',
        color: 'text-alert-hover'
      },
      active: {
        backgroundColor: 'fill-transparent-default',
        borderColor: 'fill-transparent-default',
        color: 'text-alert-pressed'
      },
      disabled: Object.assign({}, sharedDisabledTokens, {
        backgroundColor: 'fill-transparent-default',
        borderColor: 'fill-transparent-default'
      })
    },
    'link-on-dark': {
      idle: {
        backgroundColor: 'fill-transparent-default',
        borderColor: 'fill-transparent-default',
        color: 'text-inverse-default'
      },
      hover: {
        backgroundColor: 'fill-transparent-default',
        borderColor: 'fill-transparent-default',
        color: 'text-inverse-hover'
      },
      active: {
        backgroundColor: 'fill-transparent-default',
        borderColor: 'fill-transparent-default',
        color: 'text-inverse-pressed'
      },
      disabled: Object.assign({}, sharedDisabledTokens, {
        backgroundColor: 'fill-transparent-default',
        borderColor: 'fill-transparent-default'
      })
    },
    'link-on-bright': {
      idle: {
        backgroundColor: 'fill-transparent-default',
        borderColor: 'fill-transparent-default',
        color: 'text-interactive-default'
      },
      hover: {
        backgroundColor: 'fill-transparent-default',
        borderColor: 'fill-transparent-default',
        color: 'text-interactive-default-hover'
      },
      active: {
        backgroundColor: 'fill-transparent-default',
        borderColor: 'fill-transparent-default',
        color: 'text-interactive-default-pressed'
      },
      disabled: Object.assign({}, sharedDisabledTokens, {
        backgroundColor: 'fill-transparent-default',
        borderColor: 'fill-transparent-default'
      })
    },
    'view-group': {
      idle: {
        backgroundColor: 'fill-surface-raised',
        borderColor: 'border-core-default',
        color: 'text-core-subtle'
      },
      hover: {
        backgroundColor: 'fill-surface-default',
        borderColor: 'border-core-default',
        color: 'text-core-subtle',
        textDecoration: 'none'
      },
      active: {
        backgroundColor: '#e5eaf0',
        borderColor: 'border-core-default',
        color: 'text-core-subtle'
      },
      disabled: Object.assign({}, sharedDisabledTokens)
    }
  };
  return tokens[use];
};

/** @returns true if the button looks like a `<button>` */
export const isButtonUse = use => use === 'primary' || use === 'primary-white' || use === 'secondary' || use === 'secondary-ghost' || use === 'tertiary' || use === 'tertiary-light' || use === 'tertiary-extra-light' || use === 'danger' || use === 'transparent' || use === 'view-group';

/** @returns true if the button looks like a form `<input>` */
export const isFormUse = use => use === 'form' || use === 'form-on-dark';

/** @returns true if the button looks like a link `<a>` */
export const isLinkUse = use => use === 'link' || use === 'link-danger' || use === 'link-on-dark' || use === 'link-on-bright';
export const shouldButtonBeUnderlined = (use, themeName, isUsedAsLink) => isUsedAsLink && (use === 'link-on-dark' || use === 'link-on-bright') || themeName === 'trellis' && (isLinkUse(use) || isUsedAsLink && use !== 'unstyled');

/**
 * This helper retrieves size tokens for a particular size (extra-small, small, medium).
 *
 * @param size - The current variant of the Button.
 * @param use - The current variant of the Button.
 *
 * @returns A new object containing the typography, padding, and gap tokens for a particular size.
 */
export const getSizeTokens = (size, use, floatingGroup) => {
  // Tokens for common properties across variants
  const tokens = {
    medium: {
      gap: '200',
      paddingBlockStart: '250',
      paddingBlockEnd: '250',
      iconSize: '200',
      typography: 'heading-50',
      paddingInlineStart: floatingGroup ? '400' : '600',
      paddingInlineEnd: floatingGroup ? '400' : '600'
    },
    small: {
      gap: '200',
      paddingBlockStart: '200',
      paddingBlockEnd: '200',
      iconSize: '100',
      typography: 'detail-100',
      paddingInlineStart: '400',
      paddingInlineEnd: '400'
    },
    'extra-small': {
      gap: '100',
      paddingBlockStart: '100',
      paddingBlockEnd: '100',
      iconSize: '100',
      typography: 'detail-100',
      paddingInlineStart: floatingGroup ? '400' : '300',
      paddingInlineEnd: floatingGroup ? '400' : '300'
    }
  };

  // Specific adjustments for 'transparent' use
  const transparentAdjustments = {
    medium: {
      paddingInlineStart: '300',
      paddingInlineEnd: '300'
    },
    small: {
      paddingInlineStart: '200',
      paddingInlineEnd: '200'
    },
    'extra-small': {
      paddingInlineStart: '100',
      paddingInlineEnd: '100'
    }
  };

  // Specific adjustments for 'form' use
  const formAdjustments = {
    medium: {
      typography: 'body-200',
      paddingInlineStart: '300',
      paddingInlineEnd: '400'
    },
    small: {
      typography: 'detail-200',
      paddingInlineStart: '200',
      paddingInlineEnd: '300'
    },
    'extra-small': {
      typography: 'detail-200',
      paddingInlineStart: '100',
      paddingInlineEnd: '200'
    }
  };
  if (use === 'transparent') {
    tokens[size] = Object.assign({}, tokens[size], transparentAdjustments[size]);
  }
  if (isFormUse(use)) {
    tokens[size] = Object.assign({}, tokens[size], formAdjustments[size], {
      width: '100%'
    });
  }
  if (isLinkUse(use)) {
    tokens[size] = Object.assign({}, tokens[size], {
      paddingBlockStart: '0',
      paddingInlineEnd: '0',
      paddingBlockEnd: '0',
      paddingInlineStart: '0'
    });
  }
  return tokens[size];
};